<!-- Modern Admin Dashboard Layout -->

<!-- Global Loading Overlay — driven by loaderInterceptor via LoaderService -->
@if (loaderService.loading()) {
  <div class="global-loader-overlay" role="status" aria-label="Loading" aria-live="polite">
    <app-loading message="Please wait..."></app-loading>
  </div>
}

<!-- Public or Login Page - Full Width -->
@if (isLoginPage() || isPublicPage()) {
  <router-outlet></router-outlet>
} @else {
  <div class="app-layout">
    <!-- Sidebar -->
    <app-sidebar></app-sidebar>

    <!-- Main Content Area -->
    <main class="main-content">
      <!-- Header -->
      <app-header></app-header>

      <!-- Router Outlet -->
      <div class="main-content__wrapper">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>

  <!-- Error Boundary -->
  <app-error-boundary></app-error-boundary>
}

<!-- Download progress toast — persists across all page navigations -->
<app-download-toast></app-download-toast>
